<template>
  <v-container
    id="dashboard"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
    }"
    fluid
    tag="section"
    style="height: calc(100% - 110px)"
  >
    <base-material-card
      v-if="cliente && false /*nascondo dasboard*/"
      icon="mdi-newspaper-plus"
      class="px-5 py-3"
      width="100%"
    >
      <!-- {{ cliente }} -->
      <v-row justify="center">
        <v-col
          cols="12"
          md="4"
        >
          <table>
            <tr>
              <td class="text-no-wrap pr-3">
                Cliente
                <div v-if="isMobile">
                  {{ cliente.ragsoc }} {{ cliente.indiri_1 }}<br>
                  {{ cliente.indiri2 }} {{ cliente.locali }}
                </div>
              </td>
              <td v-if="!isMobile">
                {{ cliente.ragsoc }} {{ cliente.indiri_1 }}
              </td>
            </tr>
            <tr v-if="!isMobile">
              <td /><td>{{ cliente.indiri2 }} {{ cliente.locali }} </td>
            </tr>
          </table>
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="text-center"
        >
          <div class="text-h3 font-weight-light">
            Ordini Effettuati nel {{ new Date().getFullYear() }}
          </div>
          <v-row class="my-5 ">
            <v-col
              cols="12"
              md="6"
            >
              <v-img
                class="mx-auto"
                src="@/assets/SWF.png"
                width="250"
                contain
              >
                <v-chip color="orange">
                  <span style="font-size:18px">{{ qtaSwf }}</span>
                </v-chip>
              </v-img>
              <div class="mx-auto">
                SWF/CONTUR
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="text-center"
            >
              <v-img
                class="mx-auto"
                src="@/assets/JOY.png"
                width="250"
                contain
              >
                <v-chip color="orange">
                  <span style="font-size:18px">{{ qtaJoy }}</span>
                </v-chip>
              </v-img>
              JOY/JOYBAB
            </v-col>
            <!-- <v-sparkline
              type="bar"
              auto-line-width
              :gradient="['red','yellow']"
              :labels="['SWF/CONTUR','JOY/JOYBAB']"
              :value="[qtaSwf,qtaJoy]"
              label-size="10"
              auto-draw
            >
              <template v-slot:label="item">
                {{ item.index===0?qtaSwf:qtaJoy }}
                {{ item.value }}
              </template>
            </v-sparkline> -->
          </v-row>
          <!-- SWF/CONTUR <v-progress-linear
            v-model="calcSWF"
            color="red"
            height="25"
          >
            <strong>{{ qtaSwf }}</strong>
          </v-progress-linear>
          <br>
          JOY/JOY baby<v-progress-linear
            v-model="calcJOY"
            color="amber"
            height="25"
          >
            <strong>{{ qtaJoy }}</strong>
          </v-progress-linear> -->
        </v-col>
        <!--
        <v-col
          cols="12"
          md="4"
        >
          <div class="text-center">
            <div
              class="text-h3 font-weight-light mb-9"
            >
              Punti Disponibili
            </div>
            <v-icon
              :color="puntiSblocco > puntidisponibili ?'pink':'green'"
              large
            >
              {{ puntiSblocco> puntidisponibili?'mdi-lock':'mdi-lock-open' }}
            </v-icon>
            <v-progress-circular

              :rotate="180"
              :size="100"
              :width="15"
              :value="(puntidisponibili * 100)/puntiSblocco"
              :color="puntiSblocco > puntidisponibili ?'pink':'green'"
            >
              {{ puntidisponibili }} pt.
            </v-progress-circular>
            <br>Soglia sblocco: <b>{{ puntiSblocco }}</b> pt.
          </div>
        </v-col>
        -->
      </v-row>
      <!--
*
* BLOG *************************************
*
 -->
      <v-row
        v-if="blog"
      >
        <v-carousel
          cycle
          height="200"
          hide-delimiter-background
          show-arrows-on-hover
          class="ma-3"
        >
          <v-carousel-item
            v-for="(item, i) in blog"
            :key="i"
          >
            <v-sheet
              color="#efefef"
              height="100%"
            >
              <v-row
                class="fill-height px-5"
                justify="center"
              >
                <v-col
                  cols="12"
                  style="height: 170px; overflow-y: hidden"
                >
                  <v-card-subtitle>
                    <v-row class="text-caption mt-3">
                      Scritto da: {{ item.user }} <br>Data: {{ item.data_evento }}<v-spacer />
                      <v-btn
                        class="float-right"
                        color="grey"
                        small
                        @click="readmore=true; read_idx=i"
                      >
                        Leggi tutto
                      </v-btn>
                    </v-row>
                  </v-card-subtitle>
                  <div class="text-h4 px-8 py-2">
                    <v-icon
                      class="mb-2"
                      size="30"
                      :color="item.priorita==0?'gray':item.priorita==1?'blue':item.priorita==2?'green':item.priorita==3?'orange':item.priorita>4?'red':''"
                    >
                      {{ [0].includes(item.priorita)?'mdi-network-strength-outline':'' }}
                      {{ [1,2,3,4].includes(item.priorita)?'mdi-network-strength-'+item.priorita:'' }}
                      {{ [5].includes(item.priorita)?'mdi-network-strength-4':'' }}
                    </v-icon>
                    {{ item.titolo }}
                    <p

                      v-html="item.testo.trim().replace(/(?:\r\n|\r|\n)/g, '<br />')"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-row>
      <!-- FIne BLogs -->
    </base-material-card>

    <v-dialog
      v-if="blog"
      v-model="readmore"
      max-width="800"
    >
      <v-card
        class="mx-auto pa-5"
      >
        <v-card-title>
          <v-row>
            <h3>{{ blog[read_idx].titolo }} </h3>
            <v-spacer />
            <small>Data: {{ blog[read_idx].data_evento }}</small>
          </v-row>
        </v-card-title>
        <v-card-subtitle>
          <v-row class="text-caption mt-5">
            Scritto da: {{ blog[read_idx].user }}<v-spacer />
            <v-rating
              dense
              :value="blog[read_idx].priorita"
              background-color="orange lighten-3"
              color="orange"
              size="18"
              readonly
              class="text-right mb-3"
            />
          </v-row>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="mt-2">
          <p
            class="ma-0 pa-0"
            v-html="blog[read_idx].testo.trim().replace(/(?:\r\n|\r|\n)/g, '<br />')"
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="readmore = false"
          >
            Chiudi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import router from '@/router'
  import engine from '@/plugins/engine'
  import Config from '@/config.js'

  export default {
    name: 'Dashboard',
    components: {

    },
    data () {
      return {
        loading: false,
        puntiSblocco: 0,
        puntidisponibili: 0,
        cliente: null,
        qtaSwf: 0,
        qtaJoy: 0,
        blog: null,
        readmore: false,
        read_idx: 0,
      }
    },
    computed: {
      ...mapState(['auth']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      calcSWF () {
        return this.qtaSwf < 48 ? this.qtaSwf * 2.083 : this.qtaSwf
      },
      calcJOY () {
        return this.qtaJoy < 48 ? this.qtaJoy * 2.083 : this.qtaJoy
      },
    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => {
            this.showBackOnline = false
          }, 1000)
        }
      },
    },
    mounted () {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
      var codsog = this.auth.userinfo.codsog
      var coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
      var codcli = `${codsog}${coddes}`
      console.log('analisi codcli', codcli)
      console.log('config', Config)
      this.puntiSblocco = Config.puntiSblocco
      this.get_anagrafica(codcli)
      // this.riepilogo_ordQta(codcli)
      this.loadBlog()
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {

      swipe (direction) {
        if (direction === 'Left') {
          this.step++
        } else {
          this.step--
        }
      },
      updateOnlineStatus (e) {
        const { type } = e
        this.onLine = type === 'online'
      },

      get_anagrafica (codcli) {
        this.loading = true
        engine.get_anagrafica(codcli)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.cliente = result.anacli
            this.$store.commit('setCliData', result)
            this.get_puntiDisponibili(codcli)
            router.push('/view/ordini') // patch per mascherare la dasboard incompleta
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },
      get_puntiDisponibili (codcli) {
        this.loading = true
        engine.get_puntiDisponibili(codcli)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.puntidisponibili = parseInt(result.data.totpunti) || 0
            this.loading = false
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },
      // riepilogo_ordQta (codcli) {
      //   this.loading = true
      //   engine.riepilogo_ordQta(codcli)
      //     .then(result => {
      //       if (result.error) {
      //         this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
      //         this.loading = false
      //         return
      //       }
      //       console.log('ordQta', result)
      //       this.qtaSwf = (result.inline.SWF ?? 0) + (result.inline.CONTUR ?? 0) + (result.offline.SWF ?? 0) + (result.offline.CONTUR ?? 0)
      //       this.qtaJoy = (result.inline.JOY ?? 0) + (result.inline.JOYBAB ?? 0) + (result.offline.JOY ?? 0) + (result.offline.JOYBAB ?? 0)
      //       console.log('ordQta', this.qtaSwf, this.qtaJoy)
      //       this.loading = false
      //     })
      //     .catch((errore) => {
      //       console.log('search err: ', errore)
      //     }).finally(() => { this.loading = false })
      // },
      loadBlog () {
        engine.getBlogs()
          .then((result) => {
            console.log('blog', result)
            this.blog = result.blogs
          })
      },
    },

  }
</script>
